module.exports = __webpack_public_path__ + "static/media/YB5F18_5.78dccb32.jpg";